module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: _vm.cardColor
  }, [(_vm.title) ? _c('h2', {
    staticClass: "card-h2",
    class: [{
      's-icon': _vm.cardIcon
    }]
  }, [_c('span', [(_vm.cardIcon) ? _c('i', {
    staticClass: "material-icons card-icon"
  }, [_vm._v(_vm._s(_vm.cardIcon))]) : _vm._e(), _vm._v(" " + _vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('BarChart', {
    attrs: {
      "bar-color": _vm.barColor,
      "chart-data": _vm.chartData,
      "chart-height": _vm.chartHeight,
      "chart-type": _vm.chartType,
      "label-prefix": _vm.labelPrefix,
      "legend-color": _vm.legendColor,
      "legend-link": _vm.legendLink,
      "show-legend": _vm.showLegend,
      "stacked": _vm.stacked,
      "x-max-axes-rotation": _vm.xMaxAxesRotation,
      "x-min-axes-rotation": _vm.xMinAxesRotation
    }
  })], 1), _vm._v(" "), (_vm.hasResults) ? _c('button', {
    staticClass: "btn full-list-button",
    on: {
      "click": _vm.loadFullList
    }
  }, [_vm._v("Full list")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eb07546"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/barCharts/Ranks.vue
// module id = 475
// module chunks = 1